"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE = void 0;
var FILE;
(function (FILE) {
    // 大陆
    FILE["REGION_CN_SC"] = "local_region_cn_sc";
    FILE["REGION_CN_TC"] = "local_region_cn_tc";
    FILE["REGION_CN_EN"] = "local_region_cn_en";
    FILE["HOT_CITY_CN_SC"] = "local_hotcity_cn_sc";
    FILE["HOT_CITY_CN_TC"] = "local_hotcity_cn_tc";
    FILE["HOT_CITY_CN_EN"] = "local_hotcity_cn_en";
    // 中国
    FILE["REGION_CHN_SC"] = "local_region_chn_sc";
    FILE["HOT_CITY_CHN_SC"] = "local_hotcity_chn_sc";
    // 香港
    FILE["REGION_HK_SC"] = "local_region_hk_sc";
    FILE["REGION_HK_TC"] = "local_region_hk_tc";
    FILE["REGION_HK_EN"] = "local_region_hk_en";
    // 澳门
    FILE["REGION_MO_SC"] = "local_region_mo_sc";
    FILE["REGION_MO_TC"] = "local_region_mo_tc";
    FILE["REGION_MO_EN"] = "local_region_mo_en";
    // 台湾
    FILE["REGION_TW_SC"] = "local_region_tw_sc";
    FILE["REGION_TW_TC"] = "local_region_tw_tc";
    FILE["REGION_TW_EN"] = "local_region_tw_en";
    // 香港、澳门
    FILE["REGION_HK_MO_TC"] = "local_region_hk_mo_tc";
    FILE["REGION_HK_MO_EN"] = "local_region_hk_mo_en";
    // 港澳台
    FILE["REGION_HK_MO_TW_SC"] = "local_region_hk_mo_tw_sc";
    FILE["REGION_HK_MO_TW_TC"] = "local_region_hk_mo_tw_tc";
    FILE["REGION_HK_MO_TW_EN"] = "local_region_hk_mo_tw_en";
    FILE["HOT_CITY_HK_MO_TW_SC"] = "local_hotcity_hk_mo_tw_sc";
    // 国际
    FILE["HOT_CITY_JP_SC"] = "local_hotcity_japan_sc";
    FILE["HOT_CITY_KR_SC"] = "local_hotcity_korea_sc";
    FILE["HOT_CITY_MYS_SC"] = "local_hotcity_mys_sc";
    FILE["HOT_CITY_USA_SC"] = "local_hotcity_usa_sc";
    FILE["IBU_HOT_COUNTIES_SC"] = "local_ibu_hotcounties_sc";
    FILE["REGION_IBU_SC"] = "local_region_ibu_sc";
    FILE["REGION_IBU_COUNTRY_LAT_LNG_SC"] = "local_region_ibu_country_lat_lng_sc";
    FILE["REGION_JP_CITY_LAT_LNG_SC"] = "local_region_jp_city_lat_lng_sc";
    FILE["REGION_KR_CITY_LAT_LNG_SC"] = "local_region_kr_city_lat_lng_sc";
    FILE["REGION_MY_CITY_LAT_LNG_SC"] = "local_region_my_city_lat_lng_sc";
    FILE["REGION_SG_CITY_LAT_LNG_SC"] = "local_region_sg_city_lat_lng_sc";
    FILE["REGION_US_PROVINCE_LAT_LNG_SC"] = "local_region_us_province_lat_lng_sc";
    // 院校信息
    FILE["COLLEGE_CN_SC"] = "local_college_cn_sc";
    // DECLARE
})(FILE = exports.FILE || (exports.FILE = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/common/file.js
// module id = 0NxT
// module chunks = 1